import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "../AdminLayout/AdminLayout";
import Dashboard from "../Dashboard/Dashboard";
import AddDoctor from "../AddDoctor/AddDoctor";
import BulkUpload from "../BulkUpload/BulkUpload";
import EditDoctor from "../Doctor/EditDoctor";
import DoctorProfile from "../Doctor/DoctorProfile";

import Landing from "../Landing/Landing";
import BrandPage from "../Landing/BrandPage";

// Login routes
import Login from "../Login/Login";
import AdminLogin from "../Login/AdminLogin";
import DoctorLogin from "../Login/DoctorLogin";
import ParentTeacherLogin from "../ParentTeacher/ParentTeacherLogin";

// DEV bypass login page
import DoctorAutoLogin from "../Dev/DoctorAutoLogin";

// Doctor public pages
import DoctorApply from "../Doctor/DoctorApply";
import DoctorSignup from "../DoctorSignup/DoctorSignup";

import DoctorPortal from "../Doctor/DoctorPortal";
import DoctorDirectory from "../Doctor/DoctorDirectory/DoctorDirectory";

// Contact Us (PUBLIC)
import ContactUsPortal from "../ContactUs/ContactUsPortal";
import ContactUsGeneral from "../ContactUs/ContactUsGeneral";
import ContactUsIssues from "../ContactUs/ContactUsIssues";
import ContactUsSurvey from "../ContactUs/ContactUsSurvey";

// Admin pages
import AdminContactInbox from "../Admin/AdminContactInbox";
import AdminOrgRoster from "../Admin/AdminOrgRoster";
import AdminAvatarGallery from "../Admin/AdminAvatarGallery";
import AdminSchoolApprovals from "../Admin/AdminSchoolApprovals";
import AdminDoctorRoster from "../Admin/AdminDoctorRoster";
import AdminTipsGallery from "../Admin/AdminTipsGallery";
import AdminAnalyticsDashboard from "../Admin/AdminAnalyticsDashboard";
import AdminBackups from "../Admin/AdminBackups";
import AdminAuraPortal from "../Admin/AdminAuraPortal";

// School admin pages
import SchoolAdminPortal from "../SchoolAdmin/SchoolAdminPortal";
import SchoolAdminDashboard from "../SchoolAdmin/SchoolAdminDashboard";

// PUBLIC School Registration form
import SchoolRegistration from "../SchoolAdmin/SchoolRegistration";

// Student login + portal
import StudentLogin from "../Student/StudentLogin";
import StudentPortal from "../Student/StudentPortal";
import RegistrationPortals from "../RegistrationPortals/RegistrationPortals";

// Student Tips pages
import StudentTipsHome from "../Student/StudentTipsHome";
import StudentTipsPage from "../Student/StudentTipsPage";

// Parent / Teacher portal
import ParentTeacherPortal from "../ParentTeacher/ParentTeacherPortal";
import ParentPortal from "../Parent/ParentPortal";
import TeacherPortal from "../Teacher/TeacherPortal";
import SchoolErhWorkspace from "../AuraERH/SchoolErhWorkspace";
import AppAdminErhWorkspace from "../AuraERH/AppAdminErhWorkspace";
import AdvisorErhWorkspace from "../AuraERH/AdvisorErhWorkspace";
import ParentTeacherTipsHome from "../ParentTeacher/ParentTeacherTipsHome";
import ParentTeacherTipsPage from "../ParentTeacher/ParentTeacherTipsPage";

function pickFirst(...vals: Array<string | null | undefined>): string {
  for (const v of vals) {
    const s = String(v || "").trim();
    if (s) return s;
  }
  return "";
}

function normalizeRole(v: string): string {
  const s = String(v || "").trim().toLowerCase();
  if (!s) return "";
  if (s === "schooladmin" || s === "school-admin" || s === "school_admin") return "school_admin";
  if (s === "school") return "school";
  if (s === "pt" || s === "parentteacher" || s === "parent_teacher") return "pt";
  return s;
}

function getRole(): string {
  return normalizeRole(
    pickFirst(
      localStorage.getItem("role"),
      sessionStorage.getItem("role"),
      localStorage.getItem("user_role"),
      sessionStorage.getItem("user_role"),
      localStorage.getItem("account_role"),
      sessionStorage.getItem("account_role")
    )
  );
}

function getTokenFor(role: "admin" | "doctor" | "student" | "parent" | "teacher" | "pt" | "school" | "any"): string {
  if (role === "doctor") {
    return pickFirst(
      localStorage.getItem("doctor_access_token"),
      localStorage.getItem("doctor_token"),
      sessionStorage.getItem("doctor_access_token"),
      sessionStorage.getItem("doctor_token"),
      localStorage.getItem("access_token"),
      localStorage.getItem("token"),
      sessionStorage.getItem("access_token"),
      sessionStorage.getItem("token")
    );
  }

  if (role === "student") {
    return pickFirst(
      localStorage.getItem("student_access_token"),
      localStorage.getItem("student_token"),
      sessionStorage.getItem("student_access_token"),
      sessionStorage.getItem("student_token"),
      localStorage.getItem("access_token"),
      localStorage.getItem("token"),
      sessionStorage.getItem("access_token"),
      sessionStorage.getItem("token")
    );
  }

  if (role === "admin") {
    return pickFirst(
      localStorage.getItem("admin_access_token"),
      localStorage.getItem("admin_token"),
      sessionStorage.getItem("admin_access_token"),
      sessionStorage.getItem("admin_token"),
      localStorage.getItem("access_token"),
      localStorage.getItem("token"),
      sessionStorage.getItem("access_token"),
      sessionStorage.getItem("token")
    );
  }

  if (role === "parent") {
    return pickFirst(
      localStorage.getItem("parent_access_token"),
      localStorage.getItem("parent_token"),
      sessionStorage.getItem("parent_access_token"),
      sessionStorage.getItem("parent_token"),
      localStorage.getItem("pt_access_token"),
      localStorage.getItem("pt_token"),
      sessionStorage.getItem("pt_access_token"),
      sessionStorage.getItem("pt_token"),
      localStorage.getItem("access_token"),
      localStorage.getItem("token"),
      sessionStorage.getItem("access_token"),
      sessionStorage.getItem("token")
    );
  }

  if (role === "teacher") {
    return pickFirst(
      localStorage.getItem("teacher_access_token"),
      localStorage.getItem("teacher_token"),
      sessionStorage.getItem("teacher_access_token"),
      sessionStorage.getItem("teacher_token"),
      localStorage.getItem("pt_access_token"),
      localStorage.getItem("pt_token"),
      sessionStorage.getItem("pt_access_token"),
      sessionStorage.getItem("pt_token"),
      localStorage.getItem("access_token"),
      localStorage.getItem("token"),
      sessionStorage.getItem("access_token"),
      sessionStorage.getItem("token")
    );
  }

  if (role === "pt") {
    return pickFirst(
      localStorage.getItem("pt_access_token"),
      localStorage.getItem("pt_token"),
      sessionStorage.getItem("pt_access_token"),
      sessionStorage.getItem("pt_token"),
      localStorage.getItem("parent_access_token"),
      localStorage.getItem("parent_token"),
      sessionStorage.getItem("parent_access_token"),
      sessionStorage.getItem("parent_token"),
      localStorage.getItem("teacher_access_token"),
      localStorage.getItem("teacher_token"),
      sessionStorage.getItem("teacher_access_token"),
      sessionStorage.getItem("teacher_token"),
      localStorage.getItem("access_token"),
      localStorage.getItem("token"),
      sessionStorage.getItem("access_token"),
      sessionStorage.getItem("token")
    );
  }

  if (role === "school") {
    return pickFirst(
      localStorage.getItem("school_admin_token"),
      sessionStorage.getItem("school_admin_token"),
      localStorage.getItem("school_access_token"),
      sessionStorage.getItem("school_access_token"),
      localStorage.getItem("school_token"),
      sessionStorage.getItem("school_token"),
      localStorage.getItem("access_token"),
      localStorage.getItem("token"),
      sessionStorage.getItem("access_token"),
      sessionStorage.getItem("token")
    );
  }

  return pickFirst(
    localStorage.getItem("access_token"),
    localStorage.getItem("token"),
    sessionStorage.getItem("access_token"),
    sessionStorage.getItem("token"),
    localStorage.getItem("doctor_access_token"),
    localStorage.getItem("doctor_token"),
    sessionStorage.getItem("doctor_access_token"),
    sessionStorage.getItem("doctor_token"),
    localStorage.getItem("student_access_token"),
    localStorage.getItem("student_token"),
    sessionStorage.getItem("student_access_token"),
    sessionStorage.getItem("student_token"),
    localStorage.getItem("admin_access_token"),
    localStorage.getItem("admin_token"),
    sessionStorage.getItem("admin_access_token"),
    sessionStorage.getItem("admin_token"),
    localStorage.getItem("parent_access_token"),
    localStorage.getItem("parent_token"),
    sessionStorage.getItem("parent_access_token"),
    sessionStorage.getItem("parent_token"),
    localStorage.getItem("teacher_access_token"),
    localStorage.getItem("teacher_token"),
    sessionStorage.getItem("teacher_access_token"),
    sessionStorage.getItem("teacher_token"),
    localStorage.getItem("pt_access_token"),
    localStorage.getItem("pt_token"),
    sessionStorage.getItem("pt_access_token"),
    sessionStorage.getItem("pt_token"),
    localStorage.getItem("school_admin_token"),
    sessionStorage.getItem("school_admin_token"),
    localStorage.getItem("school_access_token"),
    sessionStorage.getItem("school_access_token"),
    localStorage.getItem("school_token"),
    sessionStorage.getItem("school_token")
  );
}

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();
  const adminToken = getTokenFor("admin");
  return role === "admin" && adminToken ? <>{children}</> : <Navigate to="/admin-login" replace />;
};

const UserRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();
  if (role === "admin" && getTokenFor("admin")) return <>{children}</>;
  const token = getTokenFor("any");
  return token ? <>{children}</> : <Navigate to="/login" replace />;
};

const DoctorRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();
  if (role === "admin" && getTokenFor("admin")) return <>{children}</>;
  const doctorToken = getTokenFor("doctor");
  return role === "doctor" && doctorToken ? <>{children}</> : <Navigate to="/doctor-login" replace />;
};

const StudentRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();
  if (role === "admin" && getTokenFor("admin")) return <>{children}</>;
  const studentToken = getTokenFor("student");
  return role === "student" && studentToken ? <>{children}</> : <Navigate to="/student-login" replace />;
};

const ParentTeacherRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();

  if (role === "admin" && getTokenFor("admin")) return <>{children}</>;
  if (role === "parent" && getTokenFor("parent")) return <>{children}</>;
  if (role === "teacher" && getTokenFor("teacher")) return <>{children}</>;
  if (role === "pt" && getTokenFor("pt")) return <>{children}</>;

  const shared = pickFirst(
    localStorage.getItem("pt_access_token"),
    localStorage.getItem("pt_token"),
    sessionStorage.getItem("pt_access_token"),
    sessionStorage.getItem("pt_token")
  );

  if (shared) return <>{children}</>;

  return <Navigate to="/parent-teacher-login" replace />;
};


const ParentRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();
  if (role === "admin" && getTokenFor("admin")) return <>{children}</>;
  return role === "parent" && getTokenFor("parent") ? <>{children}</> : <Navigate to="/parent-teacher-login" replace />;
};

const TeacherRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();
  if (role === "admin" && getTokenFor("admin")) return <>{children}</>;
  return role === "teacher" && getTokenFor("teacher") ? <>{children}</> : <Navigate to="/parent-teacher-login" replace />;
};

const SchoolAdminRoute = ({ children }: { children: React.ReactNode }) => {
  const role = getRole();
  const schoolToken = getTokenFor("school");

  if (role === "admin" && getTokenFor("admin")) return <>{children}</>;
  if ((role === "school" || role === "school_admin") && schoolToken) return <>{children}</>;
  if (schoolToken) return <>{children}</>;

  return <Navigate to="/school-admin" replace />;
};

export default function App() {
  const isDev = process.env.NODE_ENV !== "production";

  return (
    <Routes>
      <Route path="/" element={<BrandPage />} />
      <Route path="/landing" element={<Landing />} />

      <Route path="/contact-us" element={<ContactUsPortal />} />
      <Route path="/contact-us/general" element={<ContactUsGeneral />} />
      <Route path="/contact-us/issues" element={<ContactUsIssues />} />
      <Route path="/contact-us/survey" element={<ContactUsSurvey />} />

      {isDev && <Route path="/dev/doctor-autologin" element={<DoctorAutoLogin />} />}

      <Route path="/school-registration" element={<SchoolRegistration />} />
      <Route path="/school/register" element={<Navigate to="/school-registration" replace />} />

      <Route path="/school-admin" element={<SchoolAdminDashboard />} />
      <Route path="/school-admin/portal" element={<SchoolAdminDashboard />} />
      <Route path="/school-admin/dashboard" element={<SchoolAdminDashboard />} />
      <Route path="/school/dashboard" element={<SchoolAdminDashboard />} />
      <Route path="/school-roster-upload" element={<SchoolAdminDashboard />} />

      <Route
        path="/school-admin/legacy-portal"
        element={
          <SchoolAdminRoute>
            <SchoolAdminPortal />
          </SchoolAdminRoute>
        }
      />

      <Route path="/login" element={<Login />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/doctor-login" element={<DoctorLogin />} />
      <Route path="/admin/login" element={<Navigate to="/admin-login" replace />} />

      <Route path="/parent-teacher-login" element={<ParentTeacherLogin />} />
      <Route path="/pt-login" element={<Navigate to="/parent-teacher-login" replace />} />
      <Route path="/parent-login" element={<Navigate to="/parent-teacher-login" replace />} />
      <Route path="/teacher-login" element={<Navigate to="/parent-teacher-login" replace />} />

      <Route
        path="/parent-teacher-portal"
        element={
          <ParentTeacherRoute>
            <ParentTeacherPortal />
          </ParentTeacherRoute>
        }
      />
      <Route path="/pt-portal" element={<Navigate to="/parent-teacher-portal" replace />} />
      <Route
        path="/parent-portal"
        element={
          <ParentRoute>
            <ParentPortal />
          </ParentRoute>
        }
      />
      <Route
        path="/teacher-portal"
        element={
          <TeacherRoute>
            <TeacherPortal />
          </TeacherRoute>
        }
      />

      <Route
        path="/pt/tips"
        element={
          <ParentTeacherRoute>
            <ParentTeacherTipsHome />
          </ParentTeacherRoute>
        }
      />
      <Route
        path="/pt/tips/:category"
        element={
          <ParentTeacherRoute>
            <ParentTeacherTipsPage />
          </ParentTeacherRoute>
        }
      />
      <Route path="/parent/tips" element={<ParentRoute><ParentTeacherTipsHome /></ParentRoute>} />
      <Route path="/teacher/tips" element={<TeacherRoute><ParentTeacherTipsHome /></TeacherRoute>} />

      <Route path="/registration-portals" element={<RegistrationPortals />} />

      <Route path="/student-login" element={<StudentLogin />} />
      <Route path="/student" element={<Navigate to="/student-login" replace />} />
      <Route
        path="/student-portal"
        element={
          <StudentRoute>
            <StudentPortal />
          </StudentRoute>
        }
      />

      <Route
        path="/student/tips"
        element={
          <StudentRoute>
            <StudentTipsHome />
          </StudentRoute>
        }
      />
      <Route
        path="/student/tips/:category"
        element={
          <StudentRoute>
            <StudentTipsPage />
          </StudentRoute>
        }
      />

      <Route path="/apply" element={<DoctorApply />} />
      <Route path="/doctor-registration" element={<DoctorSignup />} />
      <Route path="/doctor-signup" element={<Navigate to="/doctor-registration" replace />} />
      <Route path="/doctor/portal" element={<Navigate to="/doctor-portal" replace />} />

      <Route path="/doctor-directory" element={<Navigate to="/directory" replace />} />
      <Route
        path="/directory"
        element={
          <UserRoute>
            <DoctorDirectory />
          </UserRoute>
        }
      />

      <Route
        path="/doctor-portal"
        element={
          <DoctorRoute>
            <DoctorPortal />
          </DoctorRoute>
        }
      />

      <Route path="/admin" element={<Navigate to="/dashboard" replace />} />

      <Route
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/add-doctor" element={<AddDoctor />} />
        <Route path="/bulk-upload" element={<BulkUpload />} />
        <Route path="/edit-doctor/:id" element={<EditDoctor />} />
        <Route path="/admin/doctors/:id" element={<DoctorProfile />} />

        <Route path="/admin/contact-inbox" element={<AdminContactInbox />} />
        <Route path="/admin/org-roster" element={<AdminOrgRoster />} />
        <Route path="/admin/directory" element={<DoctorDirectory />} />
        <Route path="/admin/avatar-gallery" element={<AdminAvatarGallery />} />
        <Route path="/admin/school-approvals" element={<AdminSchoolApprovals />} />
        <Route path="/admin/doctor-roster" element={<AdminDoctorRoster />} />
        <Route path="/admin/tips" element={<AdminTipsGallery />} />
        <Route path="/admin/analytics" element={<AdminAnalyticsDashboard />} />
        <Route path="/admin/aura" element={<AdminAuraPortal />} />
        <Route path="/admin/backups" element={<AdminBackups />} />
      </Route>

      <Route
        path="/school-admin/erh/:incidentId"
        element={<SchoolAdminRoute><SchoolErhWorkspace /></SchoolAdminRoute>}
      />
      <Route
        path="/admin/erh/:incidentId"
        element={<AdminRoute><AppAdminErhWorkspace /></AdminRoute>}
      />
      <Route
        path="/doctor-portal/erh/:incidentId"
        element={<DoctorRoute><AdvisorErhWorkspace /></DoctorRoute>}
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}